export default __webpack_public_path__ + "static/media/Canis2_desktop.91710c56.png";